import React, { useState } from "react";
import axios from "axios";
import moment from "moment";
import "../../css/ConsultaEnvio.css";
import Swal from "sweetalert2";

const Reportes = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [reporteSeleccionado, setReporteSeleccionado] = useState("");
  const [generando, setGenerando] = useState(false);

  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const reportesDisponibles = [
    { id: "reporteRips", nombre: "Reporte de Rips" },
    { id: "reporteUsuarios", nombre: "Reporte de Usuarios" },
  ];

  const validarFechas = () => {
    const inicio = moment(fechaInicio);
    const fin = moment(fechaFin);
    const diferencia = fin.diff(inicio, "days");

    if (!inicio.isValid() || !fin.isValid()) return false;
    if (diferencia < 0 || diferencia > 62) return false;

    return true;
  };

  const handleDescargar = async () => {
    if (!validarFechas()) {
      Swal.fire({
        toast: true,
        icon: "warning",
        title: "Las fechas no son válidas o exceden los 2 meses.",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (!reporteSeleccionado) {
      Swal.fire({
        toast: true,
        icon: "warning",
        title: "Seleccione un reporte.",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    try {
      setGenerando(true);

      const response = await axios.post(
        `${baseURL}/api/Reportes/GenerarReporte`,
        {
          nombreReporte: reporteSeleccionado,
          fechaInicio: fechaInicio,
          fechaFin: fechaFin,
        }
      );

      if (response.data.exito && response.data.rutaDescarga) {
        const ruta = baseURL + response.data.rutaDescarga;
        
        //Nombre del archivo
        const nombreArchivo = response.data.rutaDescarga.split("/").pop();

        // Endpoint para descargar
        const archivoResponse = await axios.get(
          `${baseURL}/api/Reportes/DescargarReporte?nombreArchivo=${nombreArchivo}&carpeta=ResultadosReporte`,
          { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(new Blob([archivoResponse.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nombreArchivo);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        
      } else {
        Swal.fire({
          icon: "info",
          title: "Sin datos",
          text:
            response.data.mensaje || "No hay datos para generar el reporte.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al generar el reporte",
        text: "Ocurrió un problema al generar el reporte. Intenta nuevamente.",
      });
      console.error(error);
    } finally {
      setGenerando(false); // 👈 Desactivar loading
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-header  text-white">
            <h3 className="card-title titulo">📋 Reportes</h3>
          </div>
          <div className="card-body">
            {/* Fechas */}
            <div className="form-row mb-3">
              <div className="form-group col-md-6">
                <label>
                  Fecha Inicio<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div>
              <div className="form-group col-md-6">
                <label>
                  Fecha Fin<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div>
            </div>

            {/* Reportes */}
            <div className="form-group">
              <label>
                Seleccione un reporte:<span className="text-danger">*</span>
              </label>
              <div className="d-flex flex-wrap">
                {reportesDisponibles.map((reporte) => (
                  <div
                    key={reporte.id}
                    className="custom-control custom-checkbox mr-4"
                  >
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={reporte.id}
                      checked={reporteSeleccionado === reporte.id}
                      onChange={() =>
                        setReporteSeleccionado(
                          reporteSeleccionado === reporte.id ? "" : reporte.id
                        )
                      }
                    />
                    <label
                      className="custom-control-label text-dark"
                      htmlFor={reporte.id}
                    >
                      {reporte.nombre}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Botón */}
            <button
              className="btn btn-outline-dark btn-block shadow-sm animate-masivo text-white"
              style={{
                backgroundColor: "#2E2E2E",
                width: "10%",
                fontSize: "15px",
              }}
              onClick={handleDescargar}
              disabled={generando} // 👈 Bloquear botón
            >
              Generar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reportes;
